/* @flow */

import React from "react";
import cn from "classnames";

import { Button, Wrapper } from "@crossroads/ui-components";
import CloseIcon from "icons/close.svg";
import ChevronIcon from "icons/chevron.svg";
import { useTranslate } from "@awardit/react-use-translate";

import styles from "./styles.scss";

type Props = {
  className?: string,
  onClose?: () => void,
  onBack?: () => void,
  heading: string,
  children?: React$Node,
};

const MobileNavHeader = ({ heading, children, onClose, onBack, className }: Props): React$Node => {
  const t = useTranslate();

  if (!onBack || !onClose) {
    return null;
  }

  return (
    <>
      <Wrapper className={cn(styles.header, className)}>
        {onBack &&
          <Button aria-label={t("HEADER.GO_BACK")} className={styles.back} onClick={onBack}>
            <ChevronIcon aria-label={t("ICONS.ARROW")} />
          </Button>
        }
        <span className={styles.heading}>{heading}</span>
        <Button
          aria-label={t("HEADER.CLOSE_MENU")}
          className={cn(styles.close, styles.actionButton)}
          onClick={onClose}
        >
          <CloseIcon aria-label={t("ICONS.CROSS")} />
        </Button>
      </Wrapper>

      {children}
    </>
  );
};

export default MobileNavHeader;
